import metamask from './metamask.png';
import coinbase from './coinbase.png';
import { WalletE } from 'blockchain-api/ewallets-api';

export const assets = {
  [WalletE.Metamask]: metamask,
  [WalletE.Coinbase]: coinbase,
};
